import React from 'react';
import { navigateTo } from '@/shared/utils/navigation';
import './NavbarMenu.css';

export function NavbarMenu() {
  const handleNav = (e, path) => {
    e.preventDefault();
    navigateTo(path);
  };

  return (
    <ul className="navbar-menu">
      <li className="navbar-menu__item">
        <a
          href="/features"
          className="navbar-menu__link"
          onClick={(e) => handleNav(e, '/features')}
        >
          <span>기능 소개</span>
        </a>
      </li>

      <li className="navbar-menu__item">
        <a href="#community" className="navbar-menu__link">
          <span>커뮤니티</span>
        </a>
      </li>

      <li className="navbar-menu__item">
        <a href="#download" className="navbar-menu__link">
          <span>다운로드</span>
        </a>
      </li>
    </ul>
  );
}

